// extracted by mini-css-extract-plugin
export default {"invalid-message":"BXKZOJ8X9TusIvLyrfyB"};